import type { ViewConfigAdditionalConfig } from '@salescore/core'
import { atom } from 'recoil'

const prefix = `view`

//
// 取得条件系
//

export const mustacheParameterAtom = atom<Record<string, unknown>>({
  key: `${prefix}/mustacheParameter`,
  default: {},
})

export const additionalConfigAtom = atom<ViewConfigAdditionalConfig>({
  key: `${prefix}/additionalConfigAtom`,
  default: {},
})

export const pickedIdsAtom = atom<string[]>({
  key: `${prefix}/pickedIds`,
  default: [],
})

//
// フィードバックUI
//
export interface FeedbackMessage {
  message: string
  type: 'error' | 'warn' | 'info'
}

export const errorsAtom = atom<string[]>({
  key: `${prefix}/errors`,
  default: [],
})

// eslint-disable-next-line sonarjs/todo-tag
// TODO: suspense?
export const loadingAtom = atom<boolean>({
  key: `${prefix}/loading`,
  default: false,
})

export const isSavingAtom = atom<boolean>({
  key: `${prefix}/isSaving`,
  default: false,
})
